// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { FunctionalComponent, h } from '@stencil/core';
import { JSXBase } from '@stencil/core/internal';

type Props = {
    'href': string;
    'class'?: string;
    'target'?: string;
    'rel'?: string;
    'title'?: string;
    'id'?: string;
    'onClick'?: (event: MouseEvent) => void;
    'style'?: JSXBase.HTMLAttributes<HTMLElement>['style'];
    'part'?: string;
    'data-mrf-conversion'?: string;
    'marfeelAction'?: string;
};

const NoFollowLink: FunctionalComponent<Props> = (props: Props, children) => {
    if (props.marfeelAction && props.href) {
        props = { ...props, 'data-mrf-conversion': props.marfeelAction };
    }
    if (props.href && props.href.includes('switchboard') && !props.marfeelAction) {
        props = { ...props, 'data-mrf-conversion': 'switchboard-click' };
    }

    return (
        <a rel="nofollow noopener" {...props}>
            {children}
        </a>
    );
};

export default NoFollowLink;
